export enum ACCOUNT_STATUS {
  VERIFIED = "VERIFIED",
  UNVERIFIED = "UNVERIFIED",
  LOCKED = "LOCKED",
  TOBEDELETED = "TOBEDELETED",
  ARCHIVED = "ARCHIVED",
}

export enum TRANSACTION_STATUS {
  COMPLETED = "Completed",
  PENDING = "Pending",
  FAILED = "Failed",
}

export type User = {
  omneId: string;
  signupCountry: string;
  accountCreationDate: string;
  omneName: string;
  phoneNumber?: string;
  email?: string;
  dob: string;
  gender: string;
  insuranceLinkedDate: string;
  campaignCode: string;
  accountStatus: string;
  primaryLoginAttribute?: string;
};

export type Pagination = {
  currentPage: number;
  pageSize: number;
  totalPages: number;
};

export type Customer = {
  users: User[];
  pagination: Pagination;
};

export type CustomerInfo = {
  omneId: string;
  signupCountry: string;
  accountCreationDate: string;
  omneName: string;
  phoneNumber: number;
  email: string;
  dob: string;
  gender: string;
  referralCode: string;
  insuranceLinkedDate: string;
  campaignCode: string;
  accountStatus: string;
  updatedDateTime: string;
  lastActiveDateTime: string;
  deviceMakeAndModel: string;
  availableRewardPoints: number;
  totalEarned: number;
  totalBurned: number;
}

export type CustomerInfoResponse = {
  data: CustomerInfo;
};

export type TransactionRedemption =  {
  omneId: string;
  dateTime: string;
  points: number;
  type: string;
  itemName: string;
};

export type RedemptionHistory = {
  transactions: TransactionRedemption[]
  pagination: Pagination;
}

export type RedemptionHistoryResponse = {
  data: RedemptionHistory;
};

export type InsuranceInfo = {
  omneId: string;
  firstName: string;
  lastName: string;
  gender: string;
  customerId: string;
  clientId: string;
  memberId: string;
  dob: string;
  policyNumber: number;
  phoneNumber: number;
  email: string;
};

export type Insurance = {
  insuranceInfo: InsuranceInfo[];
  pagination: Pagination;
};

export type InsuranceResponse = {
  data: Insurance;
};

export type Transaction = {
  omneId: string;
  transationDateTime: string;
  type: string;
  transationName: string;
  transationSubType: string;
  isSTP: boolean;
  transactionStatus: string;
  policyNumber: number;
};

export type InsuranceTransaction = {
  transactions: Transaction[];
  pagination: Pagination;
};

export type InsuranceTransactionResponse = {
  data: InsuranceTransaction;
};